import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import MarshalLine from "./MarshalLine";
import React, {useState} from "react";
import {Marshal, MarshalData} from "../../fstn/marshal";
import {Paper} from "@mui/material";
import {ActionFactory} from "../../fstn/actionFactory";
import MarshalDetails from "./MarshalDetails";
import {Transition} from "../../fstn/transition";
import {RegisterValue} from "../../fstn/register";
import {Network} from "../../fstn/network";
import {RegisterReference} from "../../fstn/marshalValue";
import {ProjectDetails} from "../../redux/types/firebase";

interface Props {
    actions: Marshal[]
    factory: ActionFactory
    network: Network
    project: string
    projectDetails: ProjectDetails
    transitions: Array<Transition>,
    onChangeActionReference: (action: number, parameter: string, reference: RegisterReference | undefined) => void
    onChangeActionValue: (action: number, parameter: string, value: RegisterValue | undefined) => void
    onUpdateActions: (actions: MarshalData[]) => void
}
export default function Actions({actions, factory, network, project, projectDetails, transitions,
                                    onChangeActionReference, onChangeActionValue, onUpdateActions}: Props) {
    const [marshalDetails, setMarshalDetails] = useState<number>();
    const handleDeleteAction = (index: number) => {
        const updatedActions = (actions || []).map(action => action.serialise());

        updatedActions.splice(index, 1);
        onUpdateActions(updatedActions);
    }
    const handleDragEnd = (result: any) => {
        if (result.destination) {
            const reordered = actions.map(action => action.serialise());
            const [removed] = reordered.splice(result.source.index, 1);

            reordered.splice(result.destination.index, 0, removed);
            onUpdateActions(reordered);
        }
    };
    const handleMarshalDetailsClose = () => setMarshalDetails(undefined);
    const handleShowActionDetails = (index: number) => setMarshalDetails(index);
    const getListStyle = (isDraggingOver: boolean) => ({
        background: isDraggingOver ? "lightgrey" : ""
    });
    const handleChangeParameterValue = (key: string, value: RegisterValue | undefined) => {
        if (marshalDetails !== undefined) {
            onChangeActionValue(marshalDetails, key, value);
        }
    };
    const handleChangeParameterReference = (key: string, value: RegisterReference | undefined) => {
        if (marshalDetails !== undefined) {
            onChangeActionReference(marshalDetails, key, value);
        }
    };

    return (
        <div style={{paddingTop: 4, paddingBottom: 4}}>
            {marshalDetails !== undefined &&
                <MarshalDetails
                    factory={factory} marshal={actions[marshalDetails].serialise()} project={project}
                    projectDetails={projectDetails} network={network} transitions={transitions}
                    onChangeReference={handleChangeParameterReference}
                    onChangeValue={handleChangeParameterValue}
                    onClose={handleMarshalDetailsClose}/>}
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="action">
                    {(provided, snapshot) => (
                        <Paper ref={provided.innerRef} elevation={0} {...provided.droppableProps}
                             style={getListStyle(snapshot.isDraggingOver)}>
                            {(actions).map((marshal, index) => (
                                <Draggable key={index} draggableId={marshal.action + index} index={index}>
                                    {(provided, snapshot) => (
                                        <div key={index} ref={provided.innerRef} {...provided.draggableProps}
                                             {...provided.dragHandleProps}>
                                            <MarshalLine dragging={snapshot.isDragging} index={index} marshal={marshal}
                                                         onDelete={handleDeleteAction}
                                                         onShowDetails={handleShowActionDetails}/>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </Paper>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
    );
}